<template>
  <div>
    <BaseHeadline icon="mdi-account-hard-hat">
      <template v-slot:headlineBtns>
        <v-btn
          v-if="isTrysilhus"
          class="mr-2"
          color="primary"
          @click="openHandbook"
        >
          Personalhåndbok
        </v-btn>
        <v-btn color="primary" @click="openUserGuide"> Brukerveiledning </v-btn>
      </template>
    </BaseHeadline>
    <BaseView v-model="list">
      <template v-slot="{ element }">
        <ProfileCard v-model="profile" v-if="element.type === 'UserCard'" />
        <!-- <UserCard v-if="element.type === 'UserCard'" v-model="profile" /> -->
        <v-btn
          v-if="element.type === 'Handbook'"
          class="mb-3"
          color="primary"
          block
          large
          @click="openHandbook"
        >
          Personalhåndbok
        </v-btn>
        <v-btn
          v-if="element.type === 'UserGuide'"
          class="mb-6"
          color="primary"
          block
          large
          @click="openUserGuide"
        >
          Brukerveiledning
        </v-btn>
        <Competence v-if="element.type === 'Competence'" />
        <MyBookings v-if="element.type === 'MyBookings'" />
      </template>
    </BaseView>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import BaseView from "@/components/shared/BaseView.vue";
// import UserCard from "@/components/profile/UserCard.vue";
import ProfileCard from "@/components/profile/children/ProfileCard.vue";
import Competence from "@/components/profile/Competence.vue";
import MyBookings from "../children/MyBookings.vue";

export default Vue.extend({
  mounted() {
    this.fetchData();
  },
  methods: {
    ...mapActions({
      updateProfile: "shared/updateProfile",
      setCourses: "courses/setCourses",
    }),
    fetchData() {
      this.setCourses();
    },
    openHandbook() {
      window.open("https://handbooks.simployer.com/nb-no/handbook/100012");
    },
    openUserGuide() {
      window.open(
        "https://thg.blob.core.windows.net/public-assets/Bygg_Trysilhus-Brukerveiledning.pdf"
      );
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isTrysilhus: "shared/isTrysilhus",
    }),
    list() {
      if (this.isTrysilhus) {
        return {
          lg: [
            [{ type: "UserCard" }],
            [{ type: "MyBookings" }],
            [{ type: "Competence" }],
          ],
          md: [
            [{ type: "UserCard" }],
            [{ type: "Competence" }, { type: "MyBookings" }],
          ],
          sm: [
            [{ type: "UserCard" }],
            [
              { type: "Handbook" },
              { type: "UserGuide" },
              { type: "Competence" },
              { type: "MyBookings" },
            ],
          ],
          xs: [
            [
              { type: "UserCard" },
              { type: "Handbook" },
              { type: "UserGuide" },
              { type: "Competence" },
              { type: "MyBookings" },
            ],
          ],
        };
      } else {
        return {
          lg: [[{ type: "UserCard" }], [{ type: "Competence" }]],
          md: [[{ type: "UserCard" }], [{ type: "Competence" }]],
          sm: [
            [{ type: "UserCard" }],
            [{ type: "UserGuide" }, { type: "Competence" }],
          ],
          xs: [
            [
              { type: "UserCard" },
              { type: "UserGuide" },
              { type: "Competence" },
            ],
          ],
        };
      }
    },
  },

  components: {
    BaseView,
    BaseHeadline,
    Competence,
    ProfileCard,
    MyBookings,
  },
});
</script>
